/* Cyclonade — global.js: gallery, accordions, variants, offers, cart */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Accordions (product info + FAQ) ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.acc__head').forEach(function (head) {
      if (head.dataset.bound) return;
      head.dataset.bound = '1';
      head.addEventListener('click', function () {
        var acc = head.closest('.acc');
        var body = acc.querySelector('.acc__body');
        var open = acc.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (src) main.querySelector('img').src = src;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* ---------- Variant swatches ---------- */
  function initSwatches() {
    document.querySelectorAll('[data-swatch-group]').forEach(function (group) {
      group.querySelectorAll('.swatch').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var label = group.parentElement.querySelector('[data-swatch-value]');
          if (label) label.textContent = sw.getAttribute('data-value') || '';
          var input = group.querySelector('[name="id"], [data-variant-input]');
        });
      });
    });
  }

  /* ---------- Bundle / quantity offers ---------- */
  function initOffers() {
    var offers = document.querySelectorAll('[data-offer]');
    if (!offers.length) return;
    offers.forEach(function (offer) {
      offer.addEventListener('click', function (e) {
        e.preventDefault();
        offers.forEach(function (o) { o.classList.remove('is-active'); });
        offer.classList.add('is-active');
        var qty = offer.getAttribute('data-qty');
        var qtyInput = document.querySelector('[data-qty-input]');
        if (qtyInput && qty) qtyInput.value = qty;
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function () {});
    document.querySelectorAll('.qty').forEach(function (q) {
      var input = q.querySelector('input');
      var minus = q.querySelector('[data-minus]');
      var plus = q.querySelector('[data-plus]');
      if (minus) minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- Cart drawer (Shopify AJAX) ---------- */
  function initCart() {
    var drawer = document.getElementById('CartDrawer');
    var body = drawer ? drawer.querySelector('[data-cart-body]') : null;
    var foot = drawer ? drawer.querySelector('[data-cart-foot]') : null;
    var currency = drawer ? (drawer.getAttribute('data-currency') || 'USD') : 'USD';
    var emptyMsg = drawer ? (drawer.getAttribute('data-empty') || 'Your cart is empty.') : '';
    var removeLbl = drawer ? (drawer.getAttribute('data-remove') || 'Remove') : 'Remove';

    function money(cents) {
      try {
        return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: currency }).format((cents || 0) / 100);
      } catch (e) {
        return '$' + ((cents || 0) / 100).toFixed(2);
      }
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
    function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }

    function updateCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
      var lbl = drawer && drawer.querySelector('[data-cart-count-label]');
      if (lbl) lbl.textContent = '(' + n + ')';
    }

    function bindLines() {
      drawer.querySelectorAll('.cart-line').forEach(function (line) {
        var key = line.getAttribute('data-key');
        var qty = parseInt(line.querySelector('.cart-line__qty span').textContent, 10) || 1;
        var minus = line.querySelector('[data-cl-minus]');
        var plus = line.querySelector('[data-cl-plus]');
        var remove = line.querySelector('[data-cl-remove]');
        if (minus) minus.addEventListener('click', function () { change(key, Math.max(0, qty - 1)); });
        if (plus) plus.addEventListener('click', function () { change(key, qty + 1); });
        if (remove) remove.addEventListener('click', function () { change(key, 0); });
      });
    }

    function render(cart) {
      if (!body) return;
      updateCount(cart.item_count);
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<p class="drawer__empty">' + esc(emptyMsg) + '</p>';
        if (foot) foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(function (it) {
        var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0)
          ? '<div class="cart-line__variant">' + esc(it.variant_title) + '</div>' : '';
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        return '<div class="cart-line" data-key="' + esc(it.key) + '">'
          + '<div class="cart-line__img">' + img + '</div>'
          + '<div class="cart-line__info">'
          +   '<div class="cart-line__title">' + esc(it.product_title) + '</div>'
          +   variant
          +   '<div class="cart-line__qty">'
          +     '<button type="button" data-cl-minus aria-label="moins">\u2212</button>'
          +     '<span>' + it.quantity + '</span>'
          +     '<button type="button" data-cl-plus aria-label="plus">+</button>'
          +   '</div>'
          + '</div>'
          + '<div class="cart-line__end">'
          +   '<div class="cart-line__price">' + money(it.final_line_price) + '</div>'
          +   '<button type="button" class="cart-line__remove" data-cl-remove>' + esc(removeLbl) + '</button>'
          + '</div>'
          + '</div>';
      }).join('');
      if (foot) {
        foot.hidden = false;
        var sub = drawer.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
      }
      bindLines();
    }

    function change(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render);
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(render);
    }

    // open / close
    document.querySelectorAll('[data-cart-open]').forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (!window.fetch || !drawer) return; // fallback: follow href to /cart
        e.preventDefault();
        openDrawer();
        refresh();
      });
    });
    if (drawer) {
      drawer.querySelectorAll('[data-cart-close]').forEach(function (c) { c.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    }

    // intercept add-to-cart forms for AJAX add
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // fallback to normal submit
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function () { return refresh(); })
          .then(function () { openDrawer(); })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label || 'Add to Cart'; } });
      });
    });
  }

  /* ---------- Mobile nav drawer ---------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mnav]');
    if (!nav) return;
    function open() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-menu-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    nav.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  onReady(function () {
    initAccordions();
    initGallery();
    initSwatches();
    initOffers();
    initQty();
    initCart();
    initMobileNav();
  });
})();
